export function putUkgPunchCardData(file: FormData) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/reportsV2/upload/ukg-punch-card-data`,
    body: file,
  }
}

export function putTireDeliveryData(file: FormData) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/reportsV2/upload/tire-delivery-data`,
    body: file,
  }
}
